import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=73028cd9"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"
import style0 from "./Fotos.vue?vue&type=style&index=0&id=73028cd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports